let hostname = `${window.location.origin}/v1`;
if (hostname.includes('3000')) {
    hostname = hostname.replace('3000', '5000');
}
export {
    hostname
};